module.exports = __webpack_public_path__ + "static/media/ci.8d61e669.svg";